import '@babel/polyfill';
import 'mutationobserver-shim';

import Vue from 'vue';
import VueMoment from "vue-moment";
import VueQrcodeReader from "vue-qrcode-reader";

import './plugins/axios';
import './plugins/bootstrap-vue';

import App from './App.vue';
import router from './router';
import store from './store';

//Custom Plugins for data fetching
import BookingPlugin from "./plugins/bookings";
import WaiverPlugin from  "./plugins/waivers";
import AccountPlugin from  "./plugins/account";

Vue.use(BookingPlugin);
Vue.use(WaiverPlugin);
Vue.use(AccountPlugin);

Vue.use(VueMoment);

Vue.use(VueQrcodeReader);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
